export default `
  query getProductFiltersByCategory($filter: ProductAttributeFilterInput!) {
    products(filter: $filter) {
      aggregations(filter: {category: { includeDirectChildrenOnly: true }}) {
        label
        count
        enabled_categories
        attribute_code
        options {
          count
          label
          value
          __typename
        }
        position
        __typename
      }
      __typename
    }
  }
`;